export const environment = {
  production: true,
  apiURL: "https://lms-api.pshealthpunjab.gov.pk/api",
  encryptionPassword:"A12-s258Ad-958jLqp98cDmG",
};